import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { Check, Clear, Visibility, VisibilityOff } from "@material-ui/icons";
import { greybackground, pagePadding } from "data/commonClasses";
import CountryCode from "components/CountryCode";
import Link from "components/Link";
import PleaseWait from "components/PleaseWait";
import SEO from "components/SEO";
import SessionContext from "components/session/SessionContext";
import {
  createPassword,
  fetchFromAPI,
  handleNumber,
  handleRouter,
  setCookie,
} from "functions";
import { useContext, useState } from "react";
import useStyles from "styles/Enroll.Style";
import useTranslation from "translations/hooks/useTranslation";
import { twMerge } from "tailwind-merge";
import Text from "components/Text";
import Button from "components/Button";
import Input from "components/Input";
import PhoneInputComponent from "components/phoneInput";

export default function Enroll() {
  const classes = useStyles();
  const { t } = useTranslation();

  let {
    actions: { signup, setSession },
    session: { lang },
  } = useContext(SessionContext);
  let isAr = lang === "ar";
  const [state, updateState] = useState({
    status: "getForm",
    engId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    countryCode: "+961",
    phoneNumber: "",
    code: "",

    validatedEmail: true,
    isEngineer: false,

    newPass: "",
    conPass: "",
    showNewPass: false,
    showConPass: false,

    alreadyExistsUser: false,
    alreadyExistsReq: false,
    isWrongPass: false,
  });

  const [phoneValid, setPhoneValid] = useState({
    state: true,
    firstTime: true,
  });


  function setState(nextState) {
    updateState((prevState) => ({
      ...prevState,
      ...nextState,
    }));
  }

  function handleChange(e) {
    let { name, value } = e.target;
    setState({ [name]: value });

    if (state.isWrongPass) setState({ isWrongPass: false });
    if (state.alreadyExistsReq) setState({ alreadyExistsReq: false });
    if (state.alreadyExistsUser) setState({ alreadyExistsUser: false });
  }

  function handleShow(show) {
    state[show] ? setState({ [show]: false }) : setState({ [show]: true });
  }

  function checkEmailAddress(email) {
    email = email || state.email;
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let validated = re.test(email);
    setState({ validatedEmail: validated });
    if (state.isWrongEmail) setState({ isWrongEmail: false });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    let {
      engId,
      firstName,
      middleName,
      lastName,
      email,
      countryCode,
      phoneNumber, 
      validatedEmail,
    } = state;


    let phoneWithoutCode =phoneNumber;
    
    let reqBody = {
      engId,
      firstName,
      middleName,
      lastName,
      email,
      countryCode: `${countryCode}`,
      phoneNumber: Number(phoneWithoutCode),
    };

    if (validatedEmail) {
      setState({ status: "loading" });
      let response = await signup(reqBody);

      if (response.status == "error") {
        if ((response.responseType = "alreadyExists")) {
          let alreadyExistsReq = response.response == "Request already exists";
          let alreadyExistsUser =
            response.response == "User with same ID already exists";

          if (alreadyExistsReq) setState({ alreadyExistsReq: true });
          else setState({ alreadyExistsUser: true });

          setState({ status: "getForm" });
        } else setState({ status: "error" });
      }
      if (response.status == "success") {
        if (response.response?.isEngineer) {
          let { code } = response.response;
          setState({ isEngineer: true, code, status: "getForm" });
        } else {
          setState({ status: "done" });
        }
      }
    } else {
      setState({ isWrongEmail: true, status: "getForm" });
    }
    return false;
  }

  async function handlePassword(e) {
    e.preventDefault();
    let { engId, code, newPass, conPass } = state;
    let reqBody = { username: engId, code, newPass: createPassword(newPass) };

    if (newPass == conPass) {
      let response = await fetchFromAPI({
        api: "auth/confirmPassword",
        reqBody,
      });
      if (response.status == "success") {
        if (response.response == "done")
          handleRouter({ href: "/signin", as: "/signin" });

        let user = response.response;
        setCookie("_id", user._id, 30);
        setCookie("authToken", user.authToken, 30);
        setSession({ user });
        handleRouter({ href: "/", as: "/" });
      } else {
        setState({ error: response.response });
      }
    } else {
      setState({ isWrongPass: true, showNewPass: true, showConPass: true });
    }

    return false;
  }

  function getForm() {
    return state.isEngineer ? (
      <form onSubmit={handlePassword}>
        <div className={classes.containerContent}>
          <TextField
            required
            name="newPass"
            type={state.showNewPass ? "text" : "password"}
            value={state.newPass}
            onChange={handleChange}
            className={isAr ? classes.rootAR : classes.root}
            InputProps={{
              className: classes.multilineColor,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    type="button"
                    edge="end"
                    style={{ color: state.showNewPass ? "#F5B750" : "#344450" }}
                    onClick={() => handleShow("showNewPass")}
                  >
                    {state.showNewPass ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            placeholder={t("enterNewPass")}
          />
          <TextField
            required
            name="conPass"
            type={state.showConPass ? "text" : "password"}
            value={state.conPass}
            onChange={handleChange}
            className={isAr ? classes.rootAR : classes.root}
            InputProps={{
              className: classes.multilineColor,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    type="button"
                    edge="end"
                    style={{ color: state.showConPass ? "#F5B750" : "#344450" }}
                    onClick={() => handleShow("showConPass")}
                  >
                    {state.showConPass ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            placeholder={t("confirmNewPass")}
          />
          <div className={classes.errorText}>
            {state.isWrongPass ? t("wrongPassword") : null}
          </div>
          <Button
            title={t("submit")}
            type="submit"
            className={classes.button}
          ></Button>
        </div>
      </form>
    ) : (
      <form onSubmit={handleSubmit}>
        <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
          <Input
            required
            name="engId"
            value={state.engId}
            direction={isAr ? "rtl" : "ltr"}
            // title={t("engineerId")}
            className={`input w-full`}
            leftIconName={"ic:baseline-engineering"}
            onChange={(e) =>
              handleChange({
                target: {
                  name: e.target.name,
                  value: handleNumber(e.target.value),
                },
              })
            }
            placeholder={t("engineerId")}
          />

          <Input
            required
            name="firstName"
            value={state.firstName}
            direction={isAr ? "rtl" : "ltr"}
            // title={t("engineerId")}
            className={`input w-full`}
            onChange={handleChange}
            placeholder={t("firstName")}
          />
          <Input
            required
            name="middleName"
            value={state.middleName}
            direction={isAr ? "rtl" : "ltr"}
            // title={t("engineerId")}
            className={`input w-full`}
            onChange={handleChange}
            placeholder={t("middleName")}
          />
          <Input
            required
            name="lastName"
            value={state.lastName}
            direction={isAr ? "rtl" : "ltr"}
            // title={t("engineerId")}
            className={`input w-full`}
            onChange={handleChange}
            placeholder={t("lastName")}
          />

          <Input
            required
            name="email"
            value={state.email}
            direction={isAr ? "rtl" : "ltr"}
            // title={t("engineerId")}
            className={`input w-full`}
            onChange={(e) => {
              handleChange(e);
              checkEmailAddress(e.target.value);
            }}
            placeholder={t("email")}
            leftIconName={
              state.email == ""
                ? null
                : state.validatedEmail
                ? "material-symbols:check"
                : "ic:baseline-clear"
            }
          />

          <PhoneInputComponent
            lang={lang}
            phone_valid={phoneValid}
            phone_number={state.phoneNumber}
            onChangeCode={(newCode)=>{
              setState({ countryCode: newCode })
            }}
            onChange={(numericValue,codeData) =>{
              
              let code = codeData?.dialCode;
            
              
              // setState({ countryCode: code })
              handleChange({
                target: {
                  name: "phoneNumber",
                  value:  numericValue?.target?.value,
                },
              })
            }
             
            }
          />

          {/* <div className={classes.phoneNumberStyle}>
            <div width={"40%"}>
              <CountryCode
                required
                name="countryCode"
                size="normal"
                selectedCode={state.countryCode}
                onChange={(value) => setState({ countryCode: value.dial_code })}
                InputProps={{ className: classes.multilineColor }}
                className={isAr ? classes.rootAR : classes.root}
              />
            </div>
            <div width={"60%"}>
              <TextField
                required
                name="phoneNumber"
                value={state.phoneNumber}
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: e.target.name,
                      value: handleNumber(e.target.value),
                    },
                  })
                }
                className={isAr ? classes.rootAR : classes.root}
                variant="outlined"
                label={t("phoneNumber")}
                InputProps={{ className: classes.multilineColor }}
                placeholder={t("phoneNumber")}
              />
            </div>
          </div> */}
        </div>
        <div className={classes.errorText}>
          {state.isWrongEmail ? t("emailDoesNotExists") : null}
          {state.alreadyExistsUser ? t("alreadyExists") : null}
          {state.alreadyExistsReq ? t("requestExists") : null}
        </div>
        <div className="w-full flex items-center justify-center flex-col mt-10">
          <Button
            title={t("submit")}
            type="submit"
            className="w-40 md:w-80"
          ></Button>
          <div className="w-fit mt-4">
            <div className="flex mb-2">
              <Text
                text={t("alreadyHaveAccount")}
                className="text-input md:text-infoText mx-2"
              />

              <Link href="/signin" as="/signin">
                <a>
                  <Text
                    text={t("signIn")}
                    className="underline text-input md:text-infoText hover:text-orange"
                  />
                </a>
              </Link>
            </div>
            <div className="flex flex-wrap">
              <Text
                text={t("alreadySentRequest")}
                className="text-input md:text-infoText mx-2"
              />

              <Link href="/confirmEnroll" as="/confirmEnroll">
                <a>
                  <Text
                    text={t("verifyEnrollement")}
                    className="underline text-input md:text-infoText hover:text-orange"
                  />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </form>
    );
  }

  function getResult() {
    return (
      <div className={classes.boxdone}>
        <div
          // margin={"3% 0"}
          // border={"2px solid #F5B750"}
          // borderRadius={5}
          // padding={"2%"}
          // width={"80%"}
        >
          <FormControl variant="outlined">
            <div
              className={classes.textInformation}
              dangerouslySetInnerHTML={{ __html: t("requestEnrollment") }}
            />
          </FormControl>
        </div>
        <div
          // display={"flex"}
          // flexDirection={"row"}
          // justifyContent={"space-around"}
          // width={"100%"}
        >
          <Button
            onClick={() => handleRouter({ href: "/", as: "/" })}
            className={classes.next}
          >
            {t("ok")}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={`${pagePadding} mb-5`}>
      <SEO title={t("enroll")} description={t("enroll")} />
      <div
        className={`${greybackground} flex items-center justify-center flex-col `}
      >
        <Text
          center
          bold
          sectionTitle
          text={
            state.status == "getForm" && state.isEngineer
              ? t("enterPassword")
              : t("requestToJoin")
          }
        />
        <div className={"w-full md:w-4/5 lg:w-2/3 xl:w-7/12 mt-10"}>
          {state.status == "loading" ? <PleaseWait /> : null}
          {state.status == "error" ? (
            <Button
              onClick={() => window.location.reload()}
              className={classes.inputLabel}
              title={t("tryAgainError")}
            />
          ) : null}
          {state.status == "done" ? getResult() : null}
          {state.status == "getForm" ? getForm() : null}
        </div>
      </div>
    </div>
  );
}

Enroll.options = {
  allow: ["guest"],
  redirectTo: { href: "/", as: "/" },
};
